// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizLayout_container__ERe7n","container__header":"QuizLayout_container__header__16pBz"};